<template>
    <div class="home">
        <b-container fluid>
            <b-row>
              <b-col>
                <h1>Body Art License Pending Fees</h1>
              </b-col>
            </b-row>

            <div class="card">
              <div class="card-header">Fees</div>
              <div class="card-body">                
                  <b-row>
                      <b-col>
                       <b-table-simple hover small caption-top responsive>                          
                          <b-thead head-variant="dark">
                            <b-tr>
                              <b-th>Date</b-th>
                              <b-th>Description</b-th>
                              <b-th>Amount</b-th>
                              <b-th>Status</b-th>
                            </b-tr>
                          </b-thead>
                          <b-tbody>
                            <b-tr v-for="(tx, index) in transactions" :key="tx.paymentId">
                              <b-td>{{ tx.date }}</b-td>
                              <b-td>{{ tx.description }}</b-td>
                              <b-td>{{ tx.amount | currency }}</b-td>
                              <b-td>{{ tx.status }}</b-td>
                            </b-tr>
                          </b-tbody>
                          <b-tfoot>
                            <b-tr>
                              <b-td colspan="7" variant="secondary" class="text-right h3 pa-2">
                                Total Due: <b>{{totalDue | currency}}</b>
                              </b-td>
                            </b-tr>
                          </b-tfoot>
                        </b-table-simple>                        
                      </b-col>
                  </b-row>
              </div>
            </div>

            <b-row>
              <b-col v-if="!checkOnly">
                <b-button variant="primary" class="mr-3" style="margin-top:32px;" @click="pay">Pay Now</b-button>
              </b-col>
              <b-col v-if="checkOnly">
                  Applications with NSF fees must be paid via Money Order, Cashier's Check, or MoneyGram.
                  <b-link :to="'/checkInstructions'"
                          target="tx">Money Order, Cashier's Check, or MoneyGram payment instructions</b-link>
              </b-col>
            </b-row>
    

        </b-container>

    </div>
</template>

<script>
import axios from 'axios'
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  components: {
  },

  data: () => ({
    transactions: []
  }),
  
  mounted() {
    this.loadTransactions()
  },

  validations: {
  },

  computed: {
    totalDue: function() {
      var total = 0

      this.transactions.forEach(function(tx) { 
        if (tx.status === 'PENDING') {
          total = total + tx.amount
        }
      })

      return total
    },
    checkOnly: function () {
        return this.transactions.some(t => t.checkOnly === true)
    }
  },

  methods: {
    loadTransactions() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/payment/pending/${this.$route.params.id}`)
        .then(response => { 
          this.transactions = response.data 
        })
    },


    pay() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/payment/pay/${this.$route.params.id}`)
        .then(response => { 
           this.sendToUSBank(response.data)
      })
    },

    sendToUSBank(formData) {
        var usbForm = document.createElement('form')
        usbForm.method = 'post' 
        usbForm.action = process.env.VUE_APP_USBANK_ENDPOINT
        for (var k in formData) {
            var input = document.createElement('input')
            input.setAttribute('name', k)
            input.setAttribute('value', formData[k])
            usbForm.appendChild(input) ;
        }
        document.body.appendChild(usbForm)
        usbForm.submit()
        document.body.removeChild(usbForm) ;
    },
  }
}
</script>

<style>
</style>